import React, { FC } from 'react';
import clsx from 'clsx';
import { Typography } from '@npm-registry/eapteka-ui';
import { PreorderBannerProps } from '../types';
import { PreorderIcon } from '..';
import { usePreorder } from '../hooks/usePreorder';
import { text } from '../../../../text';
import styles from './PreorderBanner.scss';

export const PreorderBanner: FC<PreorderBannerProps> = ({
  className
}) => {
  const { count, itemsLabel, formalizeLabel } =
    usePreorder();
  const rootClassNames = clsx([styles.root, className]);

  if (count <= 0) {
    return null;
  }

  return (
    <div className={rootClassNames}>
      <PreorderIcon />
      <Typography className={styles.title}>
        <strong>
          {count} {itemsLabel}{' '}
        </strong>
        <span>
          {text['preorder.banner.title']}
          {formalizeLabel}
          {text['preorder.banner.title.second']}
        </span>
      </Typography>
    </div>
  );
};
